/**
 * Sistema de logging de errores frontend a BD maestra
 * Guarda en: mapasoft.errfrontend
 */

/**
 * Envía error al backend (BD maestra)
 */
import { secureFetch } from './authInterceptor';

async function logError(errorMsg, errorContext = '') {

  // ← Filtrar ruido de proxy/desarrollo
  const mensaje = `${errorMsg} ${errorContext}`.trim();
  if (
    mensaje.includes('Proxy erro') ||
    mensaje.includes('not valid JSON') ||
    mensaje.includes('ETIMEDOUT') ||
    mensaje.includes('Failed to fetch')
  ) return;

  try {
    const token = sessionStorage.getItem('mapasac_access_token');
    await secureFetch('/api/sqlexec_generico/log-frontend-error', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        error_msg: errorMsg,
        error_context: errorContext
      })
    });
  } catch (err) {
    // Si falla el logging, no hacer nada (evitar loop infinito)
    console.error('❌ Failed to log error to backend:', err);
  }
}

/**
 * Log error de React
 */
export function logReactError(error, componentName = 'Unknown') {
  const errorMsg = `[REACT] ${componentName}`;
  const errorContext = error.toString();
  
  console.error('🔴 React Error:', errorMsg, errorContext);
  logError(errorMsg, errorContext);
}

/**
 * Log error de JavaScript
 */
export function logJSError(message, source = 'Unknown') {
  const errorMsg = `[JS] ${source}`;
  const errorContext = message;
  
  console.error('🔴 JS Error:', errorMsg, errorContext);
  logError(errorMsg, errorContext);
}

/**
 * Log error de red
 */
export function logNetworkError(url, method, status) {
  const errorMsg = `[NETWORK] ${method} ${url}`;
  const errorContext = `Status: ${status}`;
  
  console.error('🔴 Network Error:', errorMsg, errorContext);
  logError(errorMsg, errorContext);
}

/**
 * Log error personalizado
 */
export function logCustomError(errorMsg, errorContext = '') {
  console.error('🔴 Custom Error:', errorMsg, errorContext);
  logError(errorMsg, errorContext);
}

/**
 * Log error con información de componente
 */
export function logComponentError(componentName, action, errorDetail) {
  const errorMsg = `[COMPONENT] ${componentName} - ${action}`;
  const errorContext = errorDetail;
  
  console.error('🔴 Component Error:', errorMsg, errorContext);
  logError(errorMsg, errorContext);
}

export const cacheClean = () => {
  // Limpiar SOLAMENTE los cachés de datos (NO los tokens de sesión)
  // sessionStorage.clear() fue removido: ahora vive ahí la sesión real, y este
  // helper corre en 'beforeunload', que también dispara en F5 -- limpiarlo ahí
  // mataba la sesión en cada recarga. El cierre real de pestaña ya la destruye sola.
  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && (key.startsWith('sqlexec_cache_') || key.includes('_cache'))) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach(key => localStorage.removeItem(key));  
  // 🔥 NOTA: NO eliminar 'mapasac_access_token', 'mapasac_session', etc.
  // Esos se limpian SOLO en logout
};